<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="项目负责人申报"
      width="65%"
    >
      <!-- 表单：包含验证规则 -->
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <div class="title">选择申报批次</div>
        <el-table
          ref="singleTable"
          :data="form.templateTableData"
          border
          row-key="id"
          style="margin-top: 20px"
          @selection-change="handleTemplateSelectionChange"
        >
          <el-table-column
            align="center"
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            align="center"
            label="序号"
            type="index"
            width="60px"
          ></el-table-column>
          <el-table-column
            align="center"
            label="审核批次"
            prop="sbpc"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="审核名称"
            prop="name"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="报名开始时间"
            prop="startTime"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="报名结束时间"
            prop="endTime"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="审核费用(会员)"
            prop="costVip"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="审核费用(非会员)"
            prop="cost"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="说明"
            prop="remark"
            show-overflow-tooltip
            width="180"
          ></el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          :loading="loading"
          :type="this.selectedTemplate ? 'primary' : 'info'"
          @click="submitForm"
          >提 交</el-button
        >
      </div>
      <vipLogin ref="vipbox"></vipLogin>
    </el-dialog>
  </div>
</template>
<script>
import {
  getCompanyCyrysGr,
  saveDeclareRecordByUserApi,
  getXmfzrDeclareTemplateCyryApi,
} from "@/api/home";
import vipLogin from "@/components/vip_login.vue";

export default {
  name: "DataSubmissionDialog",
  components: { vipLogin },
  props: {},
  data() {
    return {
      dialogVisible: false,
      selectedRows: [], // 存储所有选中的行（跨页）
      selectedTemplate: null, // 选中的模板
      form: {
        cyryTableData: [], // 从业人员表格数据
        templateTableData: [], // 项目负责人审核模版表格数据
        templateId: "", // 模版ID
        stuIds: [], // 人员ID 数组
        stuNames: [], // 人员名称 数组
      },
      // 表单验证规则
      rules: {},
      // 从业人员分页参数
      cyryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      totalCyry: 0,
      loading: false,
    };
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        // 弹窗关闭时重置数据
        this.resetData();
      }
    },
  },
  methods: {
    setData(row) {
      console.log(row, "setData");
      this.dialogVisible = true;
      this.$nextTick(() => {
        // this.getCyry();
        this.getDeclareTemplate();
        this.clearSelection();
      });
    },

    // 重置数据
    resetData() {
      this.cyryParams = {
        pageNo: 1,
        pageSize: 10,
      };
      this.selectedRows = [];
      this.selectedTemplate = null;
      this.form = {
        cyryTableData: [],
        templateTableData: [],
        templateId: "",
        stuIds: [],
        stuNames: [],
      };
    },

    // 获取从业人员数据
    getCyry() {
      getCompanyCyrysGr({
        ...this.cyryParams,
        leader: 1,
      })
        .then((res) => {
          if ([200, 0].includes(res.code)) {
            this.form.cyryTableData = res.result.records || [];
            this.totalCyry = res.result.total || 0;
            // 重新设置已选中项
            this.setSelectedRows();
          } else if (res.code === 401) {
            this.$refs["vipbox"].showLogin = true;
          }
        })
        .catch((err) => {
          console.error("获取从业人员数据失败:", err);
          this.$message.error("获取数据失败，请重试");
        });
    },

    // 从业人员分页大小改变
    handleCyrySizeChange(val) {
      this.cyryParams.pageSize = val;
      this.cyryParams.pageNo = 1;
      this.getCyry();
    },

    // 从业人员页码改变
    handleCyryCurrentChange(val) {
      this.cyryParams.pageNo = val;
      this.getCyry();
    },

    // 处理选择变化
    handleSelectionChange(selection) {
      const currentPageIds = this.form.cyryTableData.map(
        (item) => item.stuUUID,
      );

      // 移除当前页在选中列表中的旧数据
      this.selectedRows = this.selectedRows.filter(
        (item) => !currentPageIds.includes(item.stuUUID),
      );

      // 添加当前页新选中的数据
      this.selectedRows.push(...selection);

      // 基于 stuUUID 去重
      this.selectedRows = this.selectedRows.reduce((acc, current) => {
        if (!acc.some((item) => item.stuUUID === current.stuUUID)) {
          acc.push(current);
        }
        return acc;
      }, []);
    },

    // 处理模板单选变化
    handleTemplateSelectionChange(selection) {
      if (selection.length > 1) {
        // 如果选择了多个，只保留最后一个
        const lastSelection = selection[selection.length - 1];
        this.$refs.singleTable.clearSelection();
        this.$refs.singleTable.toggleRowSelection(lastSelection, true);
        this.selectedTemplate = lastSelection;
      } else {
        this.selectedTemplate = selection.length > 0 ? selection[0] : null;
      }
    },

    // 重新设置选中状态
    setSelectedRows() {
      this.$nextTick(() => {
        if (!this.$refs.cyryTable) return;

        this.form.cyryTableData.forEach((row) => {
          const isSelected = this.selectedRows.some(
            (item) => item.stuUUID === row.stuUUID,
          );
          this.$refs.cyryTable.toggleRowSelection(row, isSelected);
        });
      });
    },

    // 清空选择
    clearSelection() {
      if (this.$refs.cyryTable) {
        this.$refs.cyryTable.clearSelection();
      }
      if (this.$refs.singleTable) {
        this.$refs.singleTable.clearSelection();
      }
      this.selectedRows = [];
      this.selectedTemplate = null;
      this.form.stuIds = [];
      this.form.stuNames = [];
      this.form.templateId = "";
    },

    // 获取选中人员ID（去重）
    getSelectedStuUUIDs() {
      return [...new Set(this.selectedRows.map((item) => item.stuUUID))];
    },

    // 获取选中人员姓名
    getSelectedNames() {
      return this.selectedRows.map((item) => item.name).join(", ");
    },

    // 判断是否选中某人员
    isSelected(stuUUID) {
      return this.selectedRows.some((item) => item.stuUUID === stuUUID);
    },

    // 切换选择状态
    toggleSelection(row) {
      const index = this.selectedRows.findIndex(
        (item) => item.stuUUID === row.stuUUID,
      );
      if (index > -1) {
        // 已选中，移除
        this.selectedRows.splice(index, 1);
        this.$refs.cyryTable.toggleRowSelection(row, false);
      } else {
        // 未选中，添加
        this.selectedRows.push(row);
        this.$refs.cyryTable.toggleRowSelection(row, true);
      }
    },

    // 获取审核模板数据
    getDeclareTemplate() {
      getXmfzrDeclareTemplateCyryApi()
        .then((res) => {
          if ([200, 0].includes(res.code)) {
            this.form.templateTableData = res.result || [];
          } else if (res.code === 401) {
            this.$refs["vipbox"].showLogin = true;
          }
        })
        .catch((err) => {
          console.error("获取审核模板数据失败:", err);
          this.$message.error("获取模板数据失败，请重试");
        });
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate((isValid) => {
        if (isValid) {
          // 检查是否选择了模板
          if (!this.selectedTemplate) {
            this.$message.warning("请选择申报批次！");
            return;
          }

          // 整理表单数据
          let cyryInfo = this.$Cookies.get("cyry_user")
            ? JSON.parse(this.$Cookies.get("cyry_user"))
            : {};
          this.form.templateId = this.selectedTemplate.id;

          // 提交表单到后端
          let params = {
            saveType: "0",
            stuId: cyryInfo.studentId,
            stuName: cyryInfo.name,
            templateId: this.form.templateId,
          };
          this.loading = true;
          saveDeclareRecordByUserApi(params)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("申请已提交，请尽快缴纳费用！");
                this.dialogVisible = false;
                this.$emit("success");
              }
            })
            .catch((err) => {
              console.log("err", err);
              this.$message.error("申报失败！");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.$message.warning("表单验证失败，请检查必填项～");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .hide-upload-button {
  width: 148px;
  height: 148px;

  .el-upload--picture-card {
    width: 148px;
    height: 148px;
    display: none !important;
  }
}

/* 隐藏所有 el-table 表头的全选复选框 */
.el-table-column--selection .cell .el-checkbox {
  display: none;
}

/* 上传区域样式 */
.upload-box {
  border: 1px dashed #dcdcdc;
  border-radius: 4px;
  text-align: center;
  padding: 20px;
  cursor: pointer;
}

/* 已上传文件样式 */
.uploaded-file {
  position: relative;
  width: 148px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
}

.uploaded-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-icon {
  position: absolute;
  right: 5px;
  top: 5px;
  color: #ff4d4f;
  background-color: rgba(255, 255, 255, 0.8);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 温馨提示样式 */
.tip-text {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-top: 10px;
}
.title {
  color: #666;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.6;
  margin-top: 10px;
  margin-bottom: 10px;
}
/* 自定义上传按钮内部内容（图标+文字） */
.upload-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 148px;
}

/* 上传按钮文字 */
.upload-text {
  font-size: 14px;
  color: #606266;
  width: 100%;
  line-height: normal;
  margin-top: 5px;
}

/* 预览弹窗图片样式 */
.preview-img {
  width: 100%;
  height: auto;
  max-height: 600px;
  object-fit: contain;
}
</style>
